import { Accordion, AccordionHeader, AccordionBody, Badge, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow, Icon, Button, Callout } from "@tremor/react";
import { Provider } from "@/shared/api/providers";
import { ArrowPathIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import "./provider-form-scopes.css";
const ProviderFormScopes = ({
  provider,
  validatedScopes,
  refreshLoading,
  onRevalidate
}: {
  provider: Provider;
  validatedScopes: {
    [key: string]: string | boolean;
  };
  refreshLoading: boolean;
  onRevalidate: () => void;
}) => {
  var invalidScopesPresent = Object.values(validatedScopes).some(scope => scope !== true && scope !== undefined);
  return <Accordion className="mb-5" defaultOpen={true} data-sentry-element="Accordion" data-sentry-component="ProviderFormScopes" data-sentry-source-file="provider-form-scopes.tsx">
      <AccordionHeader data-sentry-element="AccordionHeader" data-sentry-source-file="provider-form-scopes.tsx">Scopes</AccordionHeader>
      <AccordionBody className="overflow-hidden" data-sentry-element="AccordionBody" data-sentry-source-file="provider-form-scopes.tsx">
        {provider.installed && <Button color="gray" size="xs" icon={ArrowPathIcon} onClick={onRevalidate} variant="secondary" loading={refreshLoading}>
            Validate Scopes
          </Button>}
        {provider.installed && invalidScopesPresent && <Callout title="Installed With Missing Scopes" className="mt-5" color="gray">
            Provider is installed. Ignore missing scopes if you don&apos;t need
            related features.
          </Callout>}
        <Table className="mt-5" data-sentry-element="Table" data-sentry-source-file="provider-form-scopes.tsx">
          <TableHead data-sentry-element="TableHead" data-sentry-source-file="provider-form-scopes.tsx">
            <TableRow data-sentry-element="TableRow" data-sentry-source-file="provider-form-scopes.tsx">
              <TableHeaderCell data-sentry-element="TableHeaderCell" data-sentry-source-file="provider-form-scopes.tsx">Name</TableHeaderCell>
              <TableHeaderCell data-sentry-element="TableHeaderCell" data-sentry-source-file="provider-form-scopes.tsx">Last Status</TableHeaderCell>
              <TableHeaderCell data-sentry-element="TableHeaderCell" data-sentry-source-file="provider-form-scopes.tsx">Description</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody data-sentry-element="TableBody" data-sentry-source-file="provider-form-scopes.tsx">
            {
          // provider.scopes! is because we validates scopes exists in the parent component
          provider.scopes!.map(scope => {
            let isScopeString = typeof validatedScopes[scope.name] === "string";
            let isScopeLong = false;
            if (isScopeString) {
              isScopeLong = validatedScopes[scope.name].toString().length > 100;
            }
            return <TableRow key={scope.name}>
                    <TableCell>
                      {scope.name}
                      {scope.mandatory ? <span className="text-red-400">*</span> : null}
                      {scope.mandatory_for_webhook ? <span className="text-orange-300">*</span> : null}
                    </TableCell>
                    <TableCell id="scope-badge">
                      <Badge color={validatedScopes[scope.name] === true // scope is tested and valid
                ? "emerald" : validatedScopes[scope.name] === undefined // scope was not tested
                ? "gray" : "red" // scope was tested and is a string, meaning it has an error
                } className={`truncate ${isScopeLong ? "max-w-lg" : "max-w-xs"}`}>
                        {validatedScopes[scope.name] === true ? "Valid" : validatedScopes[scope.name] === undefined ? "Not checked" : validatedScopes[scope.name]}
                      </Badge>
                    </TableCell>
                    <TableCell title={scope.description} className="max-w-xs">
                      <div className="flex items-center break-words whitespace-normal">
                        {scope.description}
                        {scope.mandatory_for_webhook ? <Icon icon={QuestionMarkCircleIcon} variant="simple" color="gray" size="sm" tooltip="Mandatory for webhook installation" /> : null}
                      </div>
                    </TableCell>
                  </TableRow>;
          })}
          </TableBody>
        </Table>
      </AccordionBody>
    </Accordion>;
};
export default ProviderFormScopes;